module.exports = __webpack_public_path__ + "img/yimi.a255a5c3.png";